/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createOrUpdateMerchantTimecardAuthorization} from '../api'

export const useMutationCreateOrUpdateMerchantTimecardAuthorization = createReactQueryMutationHook('createOrUpdateMerchantTimecardAuthorization', createOrUpdateMerchantTimecardAuthorization)
